export default __webpack_public_path__ + "static/media/Rotate_Right_Stage1.b57f109f.svg";